export default "/assets/images/update-hero-img.webp?29bc8f222efc89ad182b2efca6e38fa7";